import React, { Component } from 'react';
import _ from 'lodash';
import moment from 'moment';
import PropTypes from 'prop-types';

import { getFieldStateById, setFieldState } from 'graphql/operations';
import { compareValue, generateTemplateUpdateVariables } from './helper';

const SAVE_DEBOUNCE_TIME = 1500;

function SaveTemplateAnswerHOC(WrappedComponent) {
  return class SaveTemplateAnswer extends Component {
    static propTypes = {
      // TODO: Fix this...
      /* eslint-disable react/forbid-prop-types */
      client: PropTypes.object.isRequired,
      assessmentId: PropTypes.string.isRequired,
      recordId: PropTypes.string.isRequired,
      question: PropTypes.object.isRequired,
      fieldMutation: PropTypes.func.isRequired
      /* eslint-enable react/forbid-prop-types */
    };

    constructor(props) {
      super(props);
      this.save = _.debounce(this.save, SAVE_DEBOUNCE_TIME, { leading: false, trailing: true });
    }

    setFieldState = variables => {
      const { client } = this.props;
      return client.mutate({
        mutation: setFieldState,
        variables,
        refetchQueries: ['listFieldsState']
      });
    };

    save = async value => {
      const { assessmentId, recordId, question, client, fieldMutation } = this.props;
      const { id: fieldId, fieldType } = question;

      const sameValue = compareValue(question, value);
      if (sameValue) return;

      const updateTime = moment().toISOString();
      const mutationArgs = {
        id: fieldId,
        loading: true,
        lastUpdated: updateTime,
        fieldType,
        variables: {
          value
        }
      };

      await this.setFieldState(mutationArgs);

      fieldMutation(generateTemplateUpdateVariables(assessmentId, recordId, fieldId, value))
        .catch(error => {
          console.error('save error', fieldId, fieldType, value, error);
        })
        .finally(async () => {
          const result = await client.query({ query: getFieldStateById, variables: { id: fieldId } });
          const fieldState = result.data.getFieldStateById;

          if (updateTime === fieldState.lastUpdated) {
            const updatedMutationArgs = {
              ...mutationArgs,
              loading: false
            };
            await this.setFieldState(updatedMutationArgs);
          }
        });
    };

    render() {
      return <WrappedComponent {...this.props} save={this.save} />;
    }
  };
}

export default SaveTemplateAnswerHOC;
